var BaseView = require('../../../tool-menu/components/accordion-list/content');
var ShapeThumbnailView = require('../../../tool-menu/components/thumbnail/shape');
var AnalyticsDecorate = require('../../../../analytics/decorate');
var shapesFactory = require('../../../../factory/shapes');
var template = require('./templates/shapes.hbs');

module.exports = AnalyticsDecorate(require('../../../tool-menu/customize/analytics/shapes'), BaseView.extend({
  apiCall: 'search/shapes',
  dataName: 'shapesCategories',
  $categorySelect: null,

  initialize: function () {
    _.bindAll(this, 'loadCategoryContent', 'loadCategories');
    this.$el.closest('a').one('mousedown', this.loadCategories);
  },

  initScroll: function () {
    this.$el && BaseView.prototype.initScroll.call(this);
  },

  loadCategoryContent: function () {
    this.categoryKey = this.$categorySelect.val();
    BaseView.prototype.initialize.call(this);
  },

  loadData: function (repeat, end) {
    this.end = end;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    shapesFactory.get(this.categoryKey).then(this.onMoreData);
  },

  onMoreData: function (shapes) {
    shapes.length && this.appendThumbnails(shapes);
    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));

    this.end();
    this.scrollRefresh();
  },

  appendThumbnails: function (data) {
    var $container = this.$el.find('.thumbnail-wrapper');

    _.each(data, function (item) {
      var $view = $('<div>').addClass('thumbnail');
      var thumbnailView = new ShapeThumbnailView({
        el: $view,
        item: item
      });

      $view.appendTo($container);
    });
  },

  loadCategories: function () {
    shapesFactory.getCategories().then(_.bind(function (data) {
      var categories = _.map(data, function (stickersCategory) {
        return {
          key: stickersCategory.key,
          tag: stickersCategory.name,
          icon: 'fa fa-ellipsis-v'
        };
      });

      this.$el.html(template(categories));
      this.$categorySelect = this.$el.find('select.categories');

      this.$el = this.$el.find('.shapes-content');
      this.$categorySelect.on('change', this.loadCategoryContent);
      this.$categorySelect.trigger('change');
    }, this));
  },

  getScrollHeight: function ($target) {
    return $target.parents('.ui-dropdown-items').height() - 40;
  },

  getScrollWidth: function ($target) {
    return $target.parents('.ui-dropdown-items').width();
  }
}));
